import { useEffect, useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';
// material
import { Container, Card, Box, Stack, Button, Typography, Dialog, DialogContentText, DialogTitle, Divider, Paper, TextField, Checkbox } from '@material-ui/core';
// redux
import { useDispatch } from '../../../redux/store';
import { getLabels } from '../../../redux/slices/contact';
// routes
// import { PATH_DASHBOARD } from '../../../routes/paths';
// hooks
import useSettings from '../../../hooks/useSettings';
// components
import Page from '../../../components/Page';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import { ListContact, ContactSidebar, ContactAdd, ContactDetails } from '../../../components/_dashboard/phonebook';
import UploadContact from '../contact/ListSidebar/uploadContacrt'
import SettingContact from './ListSidebar/settingContact';
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import FormActionContact2 from '../../ActionContact/FormActionContact2';
import { ReportListContact } from '../../../components/_dashboard/report';
// ----------------------------------------------------------------------
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
// import { DialogAnimate } from '../../../components/animate';
// import Scrollbar from '../../../components/Scrollbar';
// import TextFieldsIcon from '@mui/icons-material/TextFields';
import DialogSetting from './Dialog/DialogSetting';
import DialogImportContact from './Dialog/ImportCongtact';
import DialogSettingTags from './Dialog/DialogSettingTags';
export default function Contact() {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();
  const params = useParams();
  const [openSidebar, setOpenSidebar] = useState(false);
  const [openCompose, setOpenCompose] = useState(false);
  const [contactSelected, setContactSelected] = useState([]);
  const [dowloadTab, setDowloadTab] = useState(false);
  const [contactTab, setContactTab] = useState(true);
  const [settingTab, setSettingTab] = useState(false);
  const [isShowAddContract, setIsShowAddContract] = useState(false);
  const [isRefreshContact, setIsRefreshContact] = useState(false);
  const [paramSearch, setParamSearch] = useState();
  const [records, setRecords] = useState({});
  const [isOpenImportContact, setIsOpenImportContact] = useState(false);
  const [isOpenSettingContact, setIsOpenSettingContact] = useState(false);
  const [isOpenSettingTags, setIsOpenSettingTags] = useState(false);
  const [loadingFieldContact, setLoadingFieldContact] = useState(false);
  // const [isOpenImportContact, setIsOpenImportContact] = useState(false);
  // const [isOpenImportContact, setIsOpenImportContact] = useState(false);
  const handleAddContact = () => {
    setIsShowAddContract(prev => !prev);
    handleClose();
  };
  const handleCloseAddContact = () => {
    setIsShowAddContract(false);
  };
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  }
  const handleClose = () => {
    setOpen(false);
  }
  useEffect(() => {
    dispatch(getLabels());
  }, [dispatch]);
  const handleOpenDowload = () => {
    setDowloadTab(true);
    setContactTab(false);
    setSettingTab(false);
  }
  const handleOpenContact = () => {
    // setContactSelected(true);
    setContactTab(true);
    setDowloadTab(false);
    setSettingTab(false);
  }
  const handleOpenSetting = () => {
    setSettingTab(true);
    setContactTab(false);
    setDowloadTab(false);
  }
  const renderTabContact = () => {
    if (contactTab) {
      return contactSelected ? <ContactDetails setContactSelected={setContactSelected} contactSelected={contactSelected} /> : <ListContact setRecords={setRecords} paramSearch={paramSearch} setContactSelected={setContactSelected} />
    }
  }
  const renderTabDowload = () => {
    if (dowloadTab) {
      return <UploadContact></UploadContact>
    }
  }
  const renderTabSetting = () => {
    if (settingTab) {
      return <SettingContact></SettingContact>
    }
  }
  const handleParamSearchBox = (param) => {
    if (param.channel) {
      setParamSearch({ ...paramSearch, channel: param.channel })
    }
    if (param.from_date) {
      setParamSearch({ ...paramSearch, from_date: param.from_date })
    }
    if (param.to_date) {
      setParamSearch({ ...paramSearch, to_date: param.to_date })
    }
  }
  const handleParamSearch = (e) => {
    if (e.target.name === "department") {
      setParamSearch({ ...paramSearch, [e.target.name]: e.target.value, title: "" });
    } else if (e.target.name === "title") {
      setParamSearch({ ...paramSearch, [e.target.name]: e.target.value, role: "" });
    } else {
      setParamSearch({ ...paramSearch, [e.target.name]: e.target.value });
    }
  }
  const handleParamAssigner = (param) => {
    setParamSearch({ ...paramSearch, assigned_by: param });
  }
  const resetAllSearch = () => {
    setParamSearch({});
  }
  return (
    <Page title="Khách Hàng | Voip24h">
      <Container maxWidth={themeStretch ? false : 'xl'}>
        <HeaderBreadcrumbs
          heading="Danh sách Khách Hàng"
          links={[
            { name: '' }
          ]}
          action={
            <Box width={"100%"}>
              <Stack justifyContent={"flex-end"} direction="row" spacing={2}>
                <Button variant="contained" onClick={() => setIsShowAddContract(true)} color="secondary" startIcon={<GroupAddIcon />}>
                  Thêm Danh Bạ
                </Button>
                <Button variant="contained" color="secondary" onClick={() => setIsOpenImportContact(true)} startIcon={<CloudUploadIcon />}>
                  Tải lên Danh Bạ
                </Button>
                <Button variant="contained" color="secondary" onClick={() => setIsOpenSettingContact(true)} startIcon={<SettingsSuggestIcon />}>
                  Cài Đặt Danh Bạ
                </Button>
                <Button variant="contained" color="secondary" onClick={() => setIsOpenSettingTags(true)} startIcon={<BookmarksIcon />}>
                  Cài Đặt nhãn
                </Button>
              </Stack>
            </Box>
          }
        />
        <Box sx={{ px: 1, pt: 2, pb: 1 }}>
          <ReportListContact records={records} handleParamSearchBox={handleParamSearchBox} />
        </Box>
        <ListContact
          handleParamAssigner={handleParamAssigner}
          isRefreshContact={isRefreshContact}
          setIsRefreshContact={setIsRefreshContact}
          resetAllSearch={resetAllSearch}
          paramSearch={paramSearch}
          handleParamSearch={handleParamSearch}
          setRecords={setRecords}
          numSelected={contactSelected.length}
          setParamSearch={setParamSearch}
          setContactSelected={setContactSelected}
          loadingFieldContact={loadingFieldContact} />
        {isShowAddContract && <FormActionContact2
          infoContact={{}}
          type="system"
          participants={{}}
          isRefreshContact={isRefreshContact}
          setIsRefreshContact={setIsRefreshContact}
          isOpen={isShowAddContract}
          onClose={handleCloseAddContact}
          onDeleteTask={() => { }}
        >
        </FormActionContact2>}

        <ContactAdd isOpenCompose={openCompose} onCloseCompose={() => setOpenCompose(false)} />
        {/* {isOpenSettingContact &&
            <DialogAnimate sx={{maxHeight:800}} open={isOpenSettingContact} onClose={() => setIsOpenSettingContact(false)} fullWidth maxWidth="xl">
              <DialogTitle>
                <Stack direction="row" justifyContent="flex-start" spacing={2} >
                  <TextFieldsIcon style={{ fontSize: '36px', marginTop: '10px', color: '#2978d5' }} ></TextFieldsIcon>
                  <Typography variant='h4' style={{ marginTop: '10px' }}>Thuộc tính danh bạ</Typography>
                </Stack>
              </DialogTitle>
              <Divider></Divider>
              <DialogContentText>
                <Scrollbar>
                  <SettingContact></SettingContact>
                </Scrollbar>
              </DialogContentText>
            </DialogAnimate>} */}
        {isOpenSettingContact && <DialogSetting isOpenSettingContact={isOpenSettingContact} setIsOpenSettingContact={setIsOpenSettingContact} />}
        {isOpenSettingTags && <DialogSettingTags isOpenSettingTags={isOpenSettingTags} setIsOpenSettingTags={setIsOpenSettingTags} setIsRefreshContact={setIsRefreshContact} setLoadingFieldContact={setLoadingFieldContact} />}
        {isOpenImportContact && <DialogImportContact setIsRefreshContact={setIsRefreshContact} isOpenImportContact={isOpenImportContact} setIsOpenImportContact={setIsOpenImportContact} />}

      </Container>
    </Page >
  );
}
